import { render, staticRenderFns } from "./AnagraficheDettaglioGenerale.vue?vue&type=template&id=20135453&scoped=true&"
import script from "./AnagraficheDettaglioGenerale.vue?vue&type=script&lang=js&"
export * from "./AnagraficheDettaglioGenerale.vue?vue&type=script&lang=js&"
import style0 from "./AnagraficheDettaglioGenerale.vue?vue&type=style&index=0&id=20135453&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20135453",
  null
  
)

export default component.exports